<!--  SECCION BANNERS -->
<div class="d-none d-md-block">
  <div id="carouselBC" class="carousel slide" data-ride="carousel">

    <ol class="carousel-indicators">
      <li data-target="#carouselBC" attr.data-slide-to="{{i}}" *ngFor="let banner of banners; let i = index"
        [ngClass]="(i === 0) ? 'active' : 'inactive'"></li>
    </ol>

     <!-- ------------------DETALLE PROMOCION >= Medium-Devices ----------------------->
    <div class="carousel-inner d-none d-md-block">
      <div class="carousel-item" *ngFor="let banner of banners; let i = index"
        [ngStyle]="{background: 'url(' + banner.urlImagen +')', 'background-repeat': 'no-repeat', 'background-size': '100% 100%'}"
        [ngClass]="(i === 0) ? 'active' : 'inactive'">
        <div class="container">
          <div class="row">
            <div class="col-1"></div>

            <div class="col-5">
              <div class="row" style="height: 400px;">
                <div class="col-12" style="padding-top: 11%;">
                  <div class="row p-20 text-left d-flex align-items-center"
                    style="height: 57%; background-color: #125BA8;">
                    <!-- <div class="col-12"><p class="promo-name" [innerHTML]="banner.nombre"></p></div> -->
                    <div class="col-12 promo-name-banner justify-content-center text-left" [innerHTML]="banner.nombreBanner">
                    </div>
                  </div>
                  <div class="row p-20 d-flex align-items-center" style="height: 21%; background-color: #ffffff;">
                    <div class="col-6 text-center"><img src="{{banner.comercio.urlLogoImagenBanner}}" width="125"
                        height="50"></div>
                    <div class="col-6 text-center">
                      <button type="button" class="btn btn-primary banner-show-button" style="background-color: #125BA8"
                        [routerLink]="['/showPromo',banner.idPromocion,selectedIdCard,currentPage]">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ver m&aacute;s&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-6"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- ---------END---------DETALLE PROMOCION >= Medium-Devices ----------------------->

    <div class="container d-none d-lg-block">
      <a class="carousel-control-prev" href="#carouselBC" role="button" data-slide="prev" style="left: 8%;">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselBC" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>

    <div class="container d-block d-lg-none">
      <a class="carousel-control-prev" href="#carouselBC" role="button" data-slide="prev" style="left: 8%;">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselBC" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>

  </div>

  </div>



   <!-- ------------------DETALLE PROMOCION == Small-Devices ----------------------->
   <div class="d-none d-sm-block d-md-none">
    <div id="carouselBC" class="carousel slide" data-ride="carousel" style="height: 350px;">

      <ol class="carousel-indicators">
        <li data-target="#carouselBC" attr.data-slide-to="{{i}}" *ngFor="let banner of banners; let i = index"
          [ngClass]="(i === 0) ? 'active' : 'inactive'"></li>
      </ol>


      <div class="carousel-inner">
        <div class="carousel-item" *ngFor="let banner of banners; let i = index"
          [ngStyle]="{background: 'url(' + banner.urlImagenMovil +')', 'background-repeat': 'no-repeat', 'background-size': '100% 90%'}"
          [ngClass]="(i === 0) ? 'active' : 'inactive'">
          <div class="container">
            <div class="row">

              <div class="col-6">
                <div class="row" style="height: 400px;">
                  <div class="col-12" style="padding-top: 11%;">
                    <div class="row p-20 text-left d-flex align-items-center"
                      style="height: 57%; background-color: #125BA8;">
                      <!-- <div class="col-12"><p class="promo-name" [innerHTML]="banner.nombre"></p></div> -->
                      <div class="col-12 promo-name-mobile-banner justify-content-center text-left" [innerHTML]="getMobileFormat(banner.nombreBanner)">
                      </div>
                    </div>
                    <div class="row p-20 d-flex align-items-center" style="height: 21%; background-color: #ffffff;">
                      <div class="col-6 text-center"><img src="{{banner.comercio.urlLogoImagenBanner}}" width="87"
                          height="35"></div>
                      <div class="col-6 text-center">
                        <button type="button" class="btn btn-primary banner-show-button text-center" style="background-color: #125BA8"
                          [routerLink]="['/showPromo',banner.idPromocion,selectedIdCard,1]">
                         &nbsp;Ver m&aacute;s&nbsp;
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-6"></div>
            </div>
          </div>
        </div>
      </div>


    </div>
   </div>
<!--  ENDS SECCION  BANNERS-->


 <!-- ------------------SECCION  BANNERS-- == Xtra-Small-Devices ----------------------->
 <div class="d-block d-sm-none">
  <div id="carouselBC" class="carousel slide" data-ride="carousel" style="height: 380px;">

    <ol class="carousel-indicators">
      <li data-target="#carouselBC" attr.data-slide-to="{{i}}" *ngFor="let banner of banners; let i = index"
        [ngClass]="(i === 0) ? 'active' : 'inactive'"></li>
    </ol>


    <div class="carousel-inner">
      <div class="carousel-item" *ngFor="let banner of banners; let i = index"
        [ngStyle]="{background: 'url(' + banner.urlImagenMovil +')', 'background-repeat': 'no-repeat', 'background-size': '100% 95%'}"
        [ngClass]="(i === 0) ? 'active' : 'inactive'">
        <div class="container">
          <div class="row">

            <div class="col-6">
              <div class="row" style="height: 400px;">
                <div class="col-12" style="padding-top: 11%;">
                  <div class="row p-20 text-left d-flex align-items-center"
                    style="height: 57%; background-color: #125BA8;">
                    <!-- <div class="col-12"><p class="promo-name" [innerHTML]="banner.nombre"></p></div> -->
                    <div class="col-12 promo-name-xsmobile-banner justify-content-center text-left" [innerHTML]="getXSMobileFormat(banner.nombreBanner)">
                    </div>
                  </div>
                  <div class="row p-20 d-flex align-items-center" style="height: 21%; background-color: #ffffff;">
                    <div class="col-6 text-center"><img src="{{banner.comercio.urlLogoImagenBanner}}" width="77"
                        height="28"></div>
                    <div class="col-6 text-center">
                      <button type="button" class="btn btn-primary banner-show-button text-center" style="background-color: #125BA8"
                        [routerLink]="['/showPromo',banner.idPromocion,selectedIdCard,1]">
                       &nbsp;Ver m&aacute;s&nbsp;
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-6"></div>
          </div>
        </div>
      </div>
    </div>


  </div>
 </div>
<!--  ENDS SECCION  BANNERS-->




<!--   SECCION  CARDS-->
<app-cards (selectedCard)="onCardSelected($event)"></app-cards>
<!--   END SECCION  CARDS-->


<!--   SECCION  PROMOS-->
<nav class="navbar navbar-light justify-content-center bg-light">

  <!-- Show for >= Medium Devices -->
  <div class="container d-none d-md-block nopadding justify-content-center bg-light">
    <div class="row w-100 nopadding justify-content-center">

      <div class="col-sm-0 col-md-0 col-lg-1-4 nopadding d-flex align-items-center">
        <a class="btn d-none d-lg-block"><img (click)="onPrevPage()" src="assets/img/Navegador_Izq.png" /></a>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-10 ">
        <div class="container justify-content-center">

          <div class="row w-100">
            <div class="col-lg-3 col-md-6 col-sm-12" *ngFor="let promo of promos; let i = index">
              <div class="promotion-box" [routerLink]="['/showPromo',promo.idPromocion,selectedIdCard,currentPage]"
                style="outline: transparent;" *ngIf="promo.idTipoPromocion===1">
                <img class="card-img-top" src="{{promo.urlImagen}}" alt="{{promo.nombre}}" width="221" height="168">
                <div class="card-body">
                  <img class="card-img-left" src="{{promo.comercio.urlLogoImagen}}" alt="{{promo.comercio.nombre}}"
                    width="75" height="75">
                  <h5 class="card-title commerce-name-long" *ngIf="promo.comercio.nombre.length>25">
                    {{promo.comercio.nombre}}</h5>
                  <h5 class="card-title commerce-name" *ngIf="promo.comercio.nombre.length<=25">
                    {{promo.comercio.nombre}}</h5>
                  <p class="card-text promo-name">{{promo.nombre}}</p>
                </div>
                <div class="card-footer text-right">
                  <!-- <button type="button" class="btn-bc-tertiary btn btn-xs btn-default" (click)="showPromo($event)" id="{{promo.idPromocion}}"> -->
                  <button type="button" class="btn-bc-tertiary btn btn-xs btn-default"
                    [routerLink]="['/showPromo',promo.idPromocion,selectedIdCard,currentPage]">
                    <div>
                      <span class="promo-more">Conoce m&aacute;s</span><span> </span><span><i
                          class="icon icon-chevron-right-small" aria-hidden="true"></i></span>
                    </div>
                  </button>
                </div>
              </div>
              <div class="promotion-box" style="outline: transparent;" *ngIf="promo.idTipoPromocion===3"
                (click)="goToLink(promo.urlTargetInformativa, promo.targetInformativa, promo.nombre)">
                <img class="card-img-top" src="{{promo.urlImagen}}" alt="{{promo.nombre}}" width="221" height="319">

                <div class="card-footer text-right">
                  <!-- <button type="button" class="btn-bc-tertiary btn btn-xs btn-default" (click)="showPromo($event)" id="{{promo.idPromocion}}"> -->
                  <button type="button" class="btn-bc-tertiary btn btn-xs btn-default"
                    [routerLink]="['/showPromo',promo.idPromocion,selectedIdCard,currentPage]">
                  </button>
                </div>

              </div>

              <div class="card-footer-margin">
                &nbsp;
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="col-sm-0 col-md-0 col-lg-1-4 nopadding d-flex align-items-center">
        <a class="btn d-none d-lg-block"><img (click)="onNextPage()" src="assets/img/Navegador_Der.png" /></a>
      </div>

    </div>

  </div>
  <!--END Show for >= Medium Devices -->

  <!-- Show for <= SMALL Devices -->
  <div class="container d-block d-md-none nopadding justify-content-center bg-light">


          <div class="row scrolling-wrapper-flexbox">
            <div class="promobox-mobile" *ngFor="let promo of promosMobile; let i = index">
              <div class="promotion-box" [routerLink]="['/showPromo',promo.idPromocion,selectedIdCard,currentPage]"
                style="outline: transparent;" *ngIf="promo.idTipoPromocion===1">
                <img class="card-img-top" src="{{promo.urlImagen}}" alt="{{promo.nombre}}" width="221" height="168">
                <div class="card-body">
                  <img class="card-img-left" src="{{promo.comercio.urlLogoImagen}}" alt="{{promo.comercio.nombre}}"
                    width="75" height="75">
                  <h5 class="card-title commerce-name-long" *ngIf="promo.comercio.nombre.length>25">
                    {{promo.comercio.nombre}}</h5>
                  <h5 class="card-title commerce-name" *ngIf="promo.comercio.nombre.length<=25">
                    {{promo.comercio.nombre}}</h5>
                  <p class="card-text promo-name">{{promo.nombre}}</p>
                </div>
                <div class="card-footer text-right">
                  <!-- <button type="button" class="btn-bc-tertiary btn btn-xs btn-default" (click)="showPromo($event)" id="{{promo.idPromocion}}"> -->
                  <button type="button" class="btn-bc-tertiary btn btn-xs btn-default"
                    [routerLink]="['/showPromo',promo.idPromocion,selectedIdCard,currentPage]">
                    <div>
                      <span class="promo-more">Conoce m&aacute;s</span><span> </span><span><i
                          class="icon icon-chevron-right-small" aria-hidden="true"></i></span>
                    </div>
                  </button>
                </div>
              </div>
              <div class="promotion-box" style="outline: transparent;" *ngIf="promo.idTipoPromocion===3"
                (click)="goToLink(promo.urlTargetInformativa, promo.targetInformativa, promo.nombre)">
                <img class="card-img-top" src="{{promo.urlImagen}}" alt="{{promo.nombre}}" width="221" height="319">

                <div class="card-footer text-right">
                  <!-- <button type="button" class="btn-bc-tertiary btn btn-xs btn-default" (click)="showPromo($event)" id="{{promo.idPromocion}}"> -->
                  <button type="button" class="btn-bc-tertiary btn btn-xs btn-default"
                    [routerLink]="['/showPromo',promo.idPromocion,selectedIdCard,currentPage]">
                  </button>
                </div>

              </div>

              <div class="card-footer-margin">
                &nbsp;
              </div>
            </div>
          </div>



  </div>
  <!--END Show for <=  SMALL Devices -->



</nav>


<nav class="navbar d-none d-md-block navbar-light justify-content-center bg-light">
  <div class="container bg-light justify-content-center">

    <div class="row justify-content-center">
      <div class="col-12 d-flex justify-content-center align-items-center">

        <a class="btn d-none d-md-block d-lg-none" href="#"><img (click)="onPrevPage()" src="assets/img/Navegador_Izq.png" width="15px"
            height="49px" /></a>&nbsp;
        <a class='btn' *ngFor="let page of pages">
          <img (click)="showPage($event)" class="" src="{{page.imageIcon}}" id="{{page.pageNumber}}" />
        </a>&nbsp;
        <a class="btn d-none d-md-block d-lg-none" href="#"><img (click)="onNextPage()" src="assets/img/Navegador_Der.png" width="15px"
            height="49px" /></a>

      </div>
    </div>
  </div>
</nav>

<ngx-spinner></ngx-spinner>
